import { isoToDateString, isoToDateTimeString } from "utils/date";

export default [
  { field: 'name', headerAlign: 'center', headerName: 'Касса', flex: 1,
    valueGetter: (value, row) => `${row.model} - ЗН ${row.factoryNumber}`},
  { field: 'connectedAt', headerAlign: 'center', headerName: 'Подключена', flex: 1, align: 'center',
    valueGetter: (value) => isoToDateTimeString(value)},  
  { field: 'lastConnectedAt', headerAlign: 'center', headerName: 'Связь', flex: 1, align: 'right',
    valueGetter: (value) => isoToDateTimeString(value)} 
];